// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Storage from "./components/Storage";
import axios from "axios";

Vue.config.productionTip = false

axios.interceptors.response.use(function (response) {
 return response
}, function(error) {
   alert("You are not Authorized!");
   Storage.cleanJWT();
   location.href="/";

 return Promise.reject(error)
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js